import {
  Component,
  ComponentRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  Type,
  ViewChild,
  ViewContainerRef,
  forwardRef,
} from '@angular/core';
import { Form, FormTemplate } from '@nrwl/rx-models';
import { Widget, WidgetActionData } from '../models';
import { AMENDMENT_WIDGET_HOST } from '../amendments/amendment-field.model';

import { FbAttachmentComponent } from './components/fb-attachment/fb-attachment.component';
import { FbCheckboxCompositeComponent } from './components/fb-checkbox-composite/fb-checkbox-composite.component';
import { FbContentSectionComponent } from './components/fb-content-section/fb-content-section.component';
import { FbDropdownComponent } from './components/fb-dropdown/fb-dropdown.component';
import { FbEmrMedicalHistoryComponent } from './components/fb-emr-medical-history/fb-emr-medical-history.component';
import { FbEmrShotsComponent } from './components/fb-emr-shots/fb-emr-shots.component';
import { FbEmrSoapNotesComponent } from './components/fb-emr-soap-notes/fb-emr-soap-notes.component';
import { FbEmrEquipmentComponent } from './components/fb-emr-equipment/fb-emr-equipment.component';
import { FbEmrVitalsComponent } from './components/fb-emr-vitals/fb-emr-vitals.component';
import { FbEmrInsuranceInfoComponent } from './components/fb-emr-insurance-info/fb-emr-insurance-info.component';
import { FbEmrDemographicsComponent } from './components/fb-emr-demographics/fb-emr-demographics.component';
import { FbImageComponent } from './components/fb-image/fb-image.component';
import { FbMatrixComponent } from './components/fb-matrix/fb-matrix.component';
import { FbRadioCompositeComponent } from './components/fb-radio-composite/fb-radio-composite.component';
import { FbRadioSimpleComponent } from './components/fb-radio-simple/fb-radio-simple.component';
import { FbRicheditComponent } from './components/fb-richedit/fb-richedit.component';
import { FbSignatureComponent } from './components/fb-signature/fb-signature.component';
import { FbTextComponent } from './components/fb-text/fb-text.component';
import { FbTextareaComponent } from './components/fb-textarea/fb-textarea.component';
import { FbTextboxComponent } from './components/fb-textbox/fb-textbox.component';
import { CommonModule } from '@angular/common';
import { MedicalNotesWidget } from './components/fb-emr-medical-notes/medical-notes-widget';
import { LaserWidget } from './components/fb-emr-laser/laser-widget';

@Component({
  selector: 'app-form-element',
  templateUrl: './form-element.component.html',
  styleUrls: ['./form-element.component.scss'],
  imports: [CommonModule],
  providers: [
    { provide: AMENDMENT_WIDGET_HOST, useExisting: forwardRef(() => FormElementComponent) },
  ],
})
export class FormElementComponent implements OnInit {
  @Input() payload: Widget;
  @Input() wrap: boolean;
  @Input() branded = false;
  @Input()
  public get entity() {
    return this._entity;
  }
  public set entity(value: Form | FormTemplate | any) {
    this._entity = value;
    if (this.componentRef?.instance) {
      this.componentRef.instance.entity = value;
    }
  }
  private _entity: Form | FormTemplate | any = null;
  @Input() parentId: string;
  @Input()
  public get patientId() {
    return this._patientId;
  }
  public set patientId(value: number) {
    this._patientId = value;
    if (this.componentRef?.instance) {
      this.componentRef.instance.patientId = value;
    }
  }
  private _patientId: number;

  @Input()
  public get patient() {
    return this._patient;
  }
  public set patient(value: any) {
    this._patient = value;
    if (this.componentRef?.instance) {
      this.componentRef.instance.patient = value;
    }
  }
  private _patient: any;
  @Input()
  public get appointmentId() {
    return this._appointmentId;
  }
  public set appointmentId(value: string | number | null) {
    this._appointmentId = value;
    if (this.componentRef?.instance) {
      this.componentRef.instance.appointmentId = value;
    }
  }
  private _appointmentId: string | number | null = null;

  @Input()
  public get treatmentId() {
    return this._treatmentId;
  }
  public set treatmentId(value: string | number | null) {
    this._treatmentId = value;
    if (this.componentRef?.instance) {
      this.componentRef.instance.treatmentId = value;
    }
  }
  private _treatmentId: string | number | null = null;

  @Input()
  public get appointment() {
    return this._appointment;
  }
  public set appointment(value: any) {
    this._appointment = value;
    if (this.componentRef?.instance) {
      this.componentRef.instance.appointment = value;
    }
  }
  private _appointment: any = null;
  @Input() savedFormData: any;
  @Input() showVideoSelectionOption = false;
  @Input() isRxPortal = false;
  @Input() mode = '';
  @Input()
  public get isEmrReadonly() {
    return this._isEmrReadonly;
  }
  public set isEmrReadonly(value: boolean) {
    this._isEmrReadonly = value;
    if (this.componentRef?.instance) {
      this.componentRef.instance.isEmrReadonly = value;
    }
  }
  private _isEmrReadonly = false;

  public _isDesign = false;
  @Input()
  public get isDesign() {
    return this._isDesign;
  }
  public set isDesign(value: boolean) {
    this._isDesign = value;
    if (this.componentRef?.instance) {
      this.componentRef.instance.isDesign = value;
    }
  }

  public _isPreview = false;
  @Input()
  public get isPreview() {
    return this._isPreview;
  }
  public set isPreview(value: boolean) {
    this._isPreview = value;
    if (this.componentRef?.instance) {
      this.componentRef.instance.isPreview = value;
    }
  }

  public _isPrinting = false;
  @Input()
  public get isPrinting() {
    return this._isPrinting;
  }
  public set isPrinting(value: boolean) {
    this._isPrinting = value;
    if (this.componentRef?.instance) {
      this.componentRef.instance.isPrinting = value;
    }
  }

  public _isTemplatePrint = false;
  @Input()
  public get isTemplatePrint() {
    return this._isTemplatePrint;
  }
  public set isTemplatePrint(value: boolean) {
    this._isTemplatePrint = value;
    if (this.componentRef?.instance) {
      this.componentRef.instance.isTemplatePrint = value;
    }
  }

  public _isSubmitted = false;
  @Input()
  public get isSubmitted() {
    return this._isSubmitted;
  }
  public set isSubmitted(value: boolean) {
    this._isSubmitted = value;
    if (this.componentRef?.instance) {
      this.componentRef.instance.isSubmitted = value;
    }
  }

  @Input() expandAllFaq = false;
  _selected = false;
  @Input()
  get selected() {
    return this._selected;
  }
  set selected(value) {
    this._selected = value;
    if (this.componentRef && this.componentRef.instance) {
      this.componentRef.instance.selected = value;
    }
  }
  @Output() action: EventEmitter<WidgetActionData> = new EventEmitter<WidgetActionData>();
  @Output() ready: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() discrepanciesDetected: EventEmitter<any[]> = new EventEmitter<any[]>();
  @ViewChild('widgets', { read: ViewContainerRef, static: true })
  widgets: ViewContainerRef;

  private componentRef: ComponentRef<any> | any = null;

  public widgetsMap: Record<string, Type<any>> = {
    'fb-checkbox-composite': FbCheckboxCompositeComponent,
    'fb-image': FbImageComponent,
    'fb-radio-composite': FbRadioCompositeComponent,
    'fb-radio-simple': FbRadioSimpleComponent,
    'fb-richedit': FbRicheditComponent,
    'fb-signature': FbSignatureComponent,
    'fb-matrix': FbMatrixComponent,
    'fb-textarea-composite': FbTextareaComponent,
    'fb-textbox-composite': FbTextboxComponent,
    'fb-text': FbTextComponent,
    'fb-dropdown': FbDropdownComponent,
    'fb-content-section': FbContentSectionComponent,
    'fb-attachment': FbAttachmentComponent,
    'fb-emr-medical-history': FbEmrMedicalHistoryComponent,
    'fb-emr-medical-notes': MedicalNotesWidget,
    'fb-emr-shots': FbEmrShotsComponent,
    'fb-emr-laser': LaserWidget,
    'fb-emr-soap-notes': FbEmrSoapNotesComponent,
    'fb-emr-equipment': FbEmrEquipmentComponent,
    'fb-emr-vitals': FbEmrVitalsComponent,
    'fb-emr-insurance-info': FbEmrInsuranceInfoComponent,
    'fb-emr-demographics': FbEmrDemographicsComponent,
  };

  public getMetadata(): any {
    if (
      this.componentRef?.instance &&
      typeof this.componentRef.instance.getMetadata === 'function'
    ) {
      return this.componentRef.instance.getMetadata();
    }
    return null;
  }

  ngOnInit(): void {
    const t = this.widgetsMap[this.payload.name];
    if (t) {
      this.componentRef = this.widgets.createComponent(t);
      if (this.componentRef.instance.ready) {
        this.componentRef.instance.ready.subscribe((ready) => {
          this.ready.emit(ready);
        });
      }
      this.componentRef.instance.branded = this.branded;
      this.componentRef.instance.isEmrReadonly = this.isEmrReadonly;
      this.componentRef.instance.entity = this.entity;
      // Design mode must be known before the payload arrives, because widgets initialize from it
      // in their payload setters and have to take the design-aware path from the first pass.
      this.componentRef.instance.isDesign = this.isDesign;
      this.componentRef.instance.payload = this.payload;
      this.componentRef.instance.parentId = this.parentId;
      this.componentRef.instance.hasSelectOption = this.showVideoSelectionOption;
      this.componentRef.instance.expandAllFaq = this.expandAllFaq;
      this.componentRef.instance.selected = this.selected;
      this.componentRef.instance.wrap = this.wrap;
      this.componentRef.instance.wrapContent = this.wrap;
      this.componentRef.instance.isPrinting = this.isPrinting;
      this.componentRef.instance.isTemplatePrint = this.isTemplatePrint;
      this.componentRef.instance.isPreview = this.isPreview;
      this.componentRef.instance.isRxPortal = this.isRxPortal;
      this.componentRef.instance.mode = this.mode;
      this.componentRef.instance.isSubmitted = this.isSubmitted;
      this.componentRef.instance.patientId = this.patientId;
      this.componentRef.instance.patient = this.patient;
      this.componentRef.instance.appointmentId = this.appointmentId;
      this.componentRef.instance.treatmentId = this.treatmentId;
      this.componentRef.instance.appointment = this.appointment;
      this.componentRef.instance.savedFormData = this.savedFormData;

      if (this.componentRef.instance.action) {
        this.componentRef.instance.action.subscribe((data: WidgetActionData) => {
          this.action.emit(data);
        });
      }

      // Forward discrepancy events from widgets
      if (this.componentRef.instance.onDiscrepanciesDetected) {
        this.componentRef.instance.onDiscrepanciesDetected.subscribe((discrepancies: any[]) => {
          this.discrepanciesDetected.emit(discrepancies);
        });
      }
    } else {
      // TODO: Handle unknown widget
      console.warn('Unknonwn widget: ', this.payload.name);
      this.ready.emit(true);
    }
  }
}
